/*
 * @Author: Zhouqi
 * @Date: 2025-10-30 15:50:21
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-11-18 19:30:58
 */
import { fetchConfigDataByGroupCode } from '@/services/editor';
import { fetchGroupCodesData } from '@/services/template';
import request, { ResponseProps } from '@/utils/request';

// 获取批次列表
export const getBatchList = async (data: {}): Promise<ResponseProps> => {
  const res: ResponseProps = await request('/api/rest/dhc/task/list', {
    method: 'POST',
    data,
  });
  return res;
};
// 获取批次详情
export const getBatchDetail = async (data: {}): Promise<ResponseProps> => {
  const res: ResponseProps = await request('/api/rest/dlt/cloud/batch/detail', {
    method: 'POST',
    data,
  });
  return res;
};

// 删除资产(素材)
export const deleteAsset = async (data: {}): Promise<ResponseProps> => {
  const res: ResponseProps = await request('/api/rest/dlt/asset/del', {
    method: 'POST',
    data,
  });
  return res;
};

// 删除整个批次
export const deleteBatch = async (data: {}): Promise<ResponseProps> => {
  const res = await request('/api/rest/dlt/cloud/batch/delete', {
    method: 'POST',
    data,
  });
  return res;
};

// 删除任务（主要是失败的）
export const deleteTask = async (data: {}): Promise<ResponseProps> => {
  const res = await request('/api/rest/dhc/task/delete', {
    method: 'POST',
    data,
  });
  return res;
};

// 提交字幕框，文件和语言选择的导出
export const submitTranslateExport = async (data: {}): Promise<ResponseProps> => {
  const res = await request('/api/rest/dlt/f/cloud/subtitle/translate/export', {
    method: 'POST',
    data,
  });
  return res;
};
/**
 * 字幕翻译校准导出
 */
export const resubmit = async (data: any): Promise<ResponseProps> => {
  const res = await request('/api/rest/dlt/cloud/subtitle/translate/resubmit', {
    method: 'POST',
    data,
  });
  return res;
};

// 获取字体列表
export const fetchThemeList = async () => {
  try {
    const { success, data } = await fetchGroupCodesData('subtitleTemplate');
    if (success && data.length) {
      const groupCodes = data.map((code: any) => code.groupCode).join(',');
      const ret = await fetchConfigDataByGroupCode({
        groupCodes,
        pageNum: 1,
        pageSize: 100,
      });
      return ret?.data || [];
    } else {
      throw Error('Get Font List Error');
    }
  } catch (error) {
    console.error(error);
    return [];
  }
};
